import React, { useEffect } from "react"
import { graphql } from "gatsby"
import AOS from "aos"
import { HorizontalCollageFieldsFragment } from "../../graphql-types"

import CallToAction from "./call-to-action"
import Link from "./link"

export const query = graphql`
  fragment HorizontalCollageFields on DatoCmsGalleryTeaser {
    componentId: key
    title
    blurbNode {
      childMarkdownRemark {
        html
      }
    }
    images {
      url(imgixParams: { w: "800", fm: "jpg" })
      alt
    }
    url
    urltext
    ctaType
  }
`

export interface HorizontalCollageProps
  extends HorizontalCollageFieldsFragment {
  variant?: "no-margin" | "no-menu-top" | "no-left-o-row"
}

const HorizontalCollage: React.FC<HorizontalCollageProps> = props => {
  const title = props.title ? props.title : ""
  const blurb =
    (props.blurbNode &&
      props.blurbNode &&
      props.blurbNode.childMarkdownRemark &&
      props.blurbNode.childMarkdownRemark.html) ||
    ""
  const url = props.url || ""
  const urltext = props.urltext || ""
  const images = props.images ? props.images : []
  const ctatype = props.ctaType || "button"

  useEffect(() => {
    AOS.init({
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
      offset: 200, // offset (in px) from the original trigger point

      easing: "ease", // default easing for AOS animations
    })
    AOS.refresh()
  })

  return (
    <section
      id={props.componentId}
      className={`c-horizontal-collage o-wrapper o-row ${
        props.variant ? `-${props.variant}` : ""
      }`}
    >
      <div className="c-horizontal-collage__content o-row">
        <h2 className="c-heading--b">{title}</h2>
        <div dangerouslySetInnerHTML={{ __html: blurb }} />
        {url && urltext && ctatype === "button" && (
          <CallToAction url={url} color={"green"}>
            {urltext}
          </CallToAction>
        )}

        {url && urltext && ctatype === "text" && (
          <Link to={url}>{urltext}</Link>
        )}
      </div>
      <div className="c-horizontal-collage__img-container">
        <React.Fragment>
          {images[0] && (
            <div
              className="c-horizontal-collage__img -landscape"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <img src={images[0].url} alt={images[0].alt || ""} />
            </div>
          )}
          {images[1] && (
            <div
              className="c-horizontal-collage__img -left"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <img src={images[1].url} alt={images[1].alt || ""} />
            </div>
          )}
          {images[2] && (
            <div
              className="c-horizontal-collage__img -right"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <img src={images[2].url} alt={images[2].alt || ""} />
            </div>
          )}
        </React.Fragment>
      </div>
    </section>
  )
}

export default HorizontalCollage
